import lo, { values, keyBy, get } from "lodash"
import stringify from "json-beautify"

import transportation from "./data.transportation"

const ZSX_DATA = (
  (typeof document != "undefined" && document && document.ZSX_DATA)
  || require("./data.json")
)

export const productsArray = values(ZSX_DATA.products)
export const {products} = ZSX_DATA

const foo = type => lo.chain(productsArray)
  .filter({type})
  .groupBy("city")
  .mapValues(x => lo.keyBy(x, "_id"))
  .value()

// #TODO keep these precalculated in the file!

export const restaurants = foo("restaurant")
export const tickets = foo("ticket")
export const compras = foo("shopping")
export const onedaytrips = foo("onedaytrip")

export const cities = require("./cities.json")

export const citiesArray = values(cities)

export const partners = [
  // #TODO these keys are being included in bundle.js! secure af
  { 
    _id: "1sdlkjnal", 
    key: "gn200n248g023v1",  
    name: "GoodTravel",
    domain: "goodtravel", 
    logo: "/static/img/goodtravel.jpg", 
    whitelogo: "/static/img/goodtravel_white.png",
    loadinglogo: "/static/icons/goodtravelloading.svg" 
  },
  { 
    _id: "2pqunqaa",  
    key: "nog2oasfin2nbesr", 
    name: "EasyTrip",   
    domain: "easytrip",   
    logo: "/static/img/easytrip.jpg", 
    whitelogo: "/static/img/easytrip_white.png",
    loadinglogo: "/static/icons/easytriploading.svg" 
  },
  { 
    _id: "3jfo02js",  
    key: "sk43o6tassa9kgj3", 
    name: "Lvmama",   
    domain: "lvmama",   
    logo: "/static/img/lv_logo.png", 
    whitelogo: "/static/img/lv_logo_white.png",
    loadinglogo: "/static/icons/lvmamaloading.svg",
  }
]

const types = lo.chain(productsArray).map("type").uniq().value()

const tagsArray = ZSX_DATA.tags
export const tags = keyBy(tagsArray, "_id")
export const tagsByName = keyBy(tagsArray, "name")

/* eslint-disable quote-props */
export const publicTagNames = {
  /* MUSEO */        "6efw2rfnon": { name: "博物馆", icon: "md-star" },
  /* ESPECTACULO */  "r7n6igr7gi": { name: "演出", icon: "md-star" },
  /* VISITA */       "eab2iojk81": { name: "参观", icon: "md-star" },
  /* COMPRAS */      "chzlh8hklq": { name: "购买", icon: "ios-basket" },
  /* EXPERIENCIA */  "5kuna9ccga": { name: "体验", icon: "md-star" },
  /* ENTRADAS */     "80ulgbfn21": { name: "门票", icon: "md-pricetags" },
  /* ONEDAY */       "k0bb01mkds": { name: "日游", icon: "ios-compass" },
  /* RESTAURANT */   "2sn6dbecc3": { name: "餐厅", icon: "ios-restaurant" },
}
/* eslint-enable quote-props */

const data = {
  restaurants,
  cities,
  compras,
  tickets,
  onedaytrips,
  transportation,
  partners,
  products: ZSX_DATA.products,
  productsArray,
  types,
  tagsArray,
  tags,
  tagsByName,
  publicTagNames,
  ZSX_DATA
}

export default data



// WEBPACK FOOTER //
// ./data.js